<template>
  <div>
    <!-- Section Header -->
    <div class="elementor-element elementor-element-78be238c e-flex e-con-boxed e-con e-parent" data-id="78be238c"
      data-element_type="container"
      data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}"
      data-core-v316-plus="true">
      <div class="e-con-inner">
        <div class="elementor-element elementor-element-53288905 e-flex e-con-boxed e-con e-child"
          data-id="53288905" data-element_type="container"
          data-settings="{&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}">
          <div class="e-con-inner">
            <div class="elementor-element elementor-element-180e229b elementor-widget elementor-widget-heading"
              data-id="180e229b" data-element_type="widget" data-widget_type="heading.default">
              <div class="elementor-widget-container">
                <h2 class="elementor-heading-title elementor-size-default">Shape Your Future, Seize it with
                  Wisdom<br>&amp; Begin Choosing Wisely Today.</h2>
              </div>
            </div>
            <div class="elementor-element elementor-element-9d72966 elementor-widget elementor-widget-text-editor"
              data-id="9d72966" data-element_type="widget" data-widget_type="text-editor.default">
              <div class="elementor-widget-container">
                <p>We have three account types to choose from</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Account Cards Container -->
    <div class="elementor-element elementor-element-4e1bf539 e-flex e-con-boxed e-con e-parent" data-id="4e1bf539"
      data-element_type="container"
      data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}"
      data-core-v316-plus="true">
      <div class="e-con-inner">

        <!-- Hedging Account (Recommended) -->
        <AccountCard
          account-type="stoic"
          account-name="Hedging Account"
          icon-svg-id="icon_400x400_1"
          spread="Raw"
          commission="$7"
          min-deposit="-"
          suitable-for="Hedging"
          :recommended="true"
        />

      </div>
    </div>

    <!-- CTA Section -->
    <div class="elementor-element elementor-element-64a9e102 e-flex e-con-boxed e-con e-parent" data-id="64a9e102"
      data-element_type="container"
      data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}"
      data-core-v316-plus="true">
      <div class="e-con-inner">
        <div class="elementor-element elementor-element-36c596e6 e-flex e-con-boxed e-con e-child"
          data-id="36c596e6" data-element_type="container"
          data-settings="{&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}">
          <div class="e-con-inner">
            <div class="elementor-element elementor-element-5ebb1f3 elementor-widget elementor-widget-heading"
              data-id="5ebb1f3" data-element_type="widget" data-widget_type="heading.default">
              <div class="elementor-widget-container">
                <h2 class="elementor-heading-title elementor-size-default">Not sure which one is best for you?</h2>
              </div>
            </div>
            <div class="elementor-element elementor-element-50142e96 elementor-widget elementor-widget-text-editor"
              data-id="50142e96" data-element_type="widget" data-widget_type="text-editor.default">
              <div class="elementor-widget-container">
                <p>Learn in our Demo Account with Stoic feature.</p>
              </div>
            </div>
            <div class="elementor-element elementor-element-d8da1d6 elementor-align-center elementor-widget elementor-widget-button"
              data-id="d8da1d6" data-element_type="widget" data-widget_type="button.default">
              <div class="elementor-widget-container">
                <div class="elementor-button-wrapper">
                  <router-link class="elementor-button elementor-button-link elementor-size-sm"
                    to="/signup">
                    <span class="elementor-button-content-wrapper">
                      <span class="elementor-button-text">Try Demo Account</span>
                    </span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccountCard from './AccountCard.vue'

export default {
  name: 'LandingAccountTypes',
  components: {
    AccountCard
  }
}
</script>

<style>
/* Text editor styles */
.elementor-widget-text-editor.elementor-drop-cap-view-stacked .elementor-drop-cap {
  background-color: #69727d;
  color: #fff
}

.elementor-widget-text-editor.elementor-drop-cap-view-framed .elementor-drop-cap {
  color: #69727d;
  border: 3px solid;
  background-color: transparent
}

.elementor-widget-text-editor:not(.elementor-drop-cap-view-default) .elementor-drop-cap {
  margin-top: 8px
}

.elementor-widget-text-editor:not(.elementor-drop-cap-view-default) .elementor-drop-cap-letter {
  width: 1em;
  height: 1em
}

.elementor-widget-text-editor .elementor-drop-cap {
  float: left;
  text-align: center;
  line-height: 1;
  font-size: 50px
}

.elementor-widget-text-editor .elementor-drop-cap-letter {
  display: inline-block
}

</style>